import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/auction-market-car-hammer-price-conditions.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { AuctionsHammerPrices } from "@/types/auctions";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for auction cars
  const mock = AxiosMock.getInstance();
  const uri = new RegExp("^\/carburate\/auctions\/market_cars\/.+\/hammer_price_by_conditions\/$");
  mock.onGet(uri).reply(200, data);
}

export const getAuctionMarketCarHammerPriceByConditions = (marketCarId: string) => {
  return api.get(
    `/carburate/auctions/market_cars/${marketCarId}/hammer_price_by_conditions/`
  ) as Promise<AuctionsHammerPrices>;
};

export const getAuctionMarketCarHammerPriceByConditionsQueryOptions = ({
  marketCarId,
}: {
  marketCarId: string;
}) => {
  return queryOptions({
    queryKey: ["market-car-auctions", marketCarId, "hammer-price-by-conditions"],
    queryFn: () => getAuctionMarketCarHammerPriceByConditions(marketCarId),
  });
};

type UseAuctionMarketCarHammerPriceByConditionsOptions = {
  marketCarId: string;
  queryConfig?: QueryConfig<typeof getAuctionMarketCarHammerPriceByConditions>;
};

export const useAuctionMarketCarHammerPriceByConditions = ({
  marketCarId,
  queryConfig,
}: UseAuctionMarketCarHammerPriceByConditionsOptions) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getAuctionMarketCarHammerPriceByConditionsQueryOptions({ marketCarId }),
    ...queryConfig,
  });
};
